import { WA_LINK, PHONE_TEL, WA_NUMBER_DISPLAY, ADDRESS } from "../site";
import { WhatsAppIcon } from "./WhatsAppIcon";

export const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-white/10">
    <div className="max-w-7xl mx-auto px-6 md:px-10 py-16 md:py-20">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-10">
        <div>
          <p className="font-serif text-3xl md:text-4xl font-light tracking-tight text-stone-100">
            Relax <span className="italic text-gold-400">Massage Spa</span>
          </p>
          <p className="mt-4 max-w-sm text-sm font-light text-stone-400 leading-relaxed">{ADDRESS}</p>
        </div>
        <div className="flex flex-col items-start gap-3 text-sm text-stone-300">
          <a href={WA_LINK} target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp-link" className="inline-flex items-center gap-2 hover:text-wa transition-colors duration-300">
            <WhatsAppIcon className="w-4 h-4" /> WhatsApp {WA_NUMBER_DISPLAY}
          </a>
          <a href={PHONE_TEL} data-testid="footer-phone-link" className="hover:text-gold-400 transition-colors duration-300">
            Call {WA_NUMBER_DISPLAY}
          </a>
        </div>
      </div>
      <div className="mt-14 pt-8 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-4 text-xs text-stone-500">
        <p>© {new Date().getFullYear()} Relax Massage Spa, Bur Dubai. All rights reserved.</p>
        <p>Open 24 hours · Walk-ins welcome</p>
      </div>
    </div>
  </footer>
);
